const DEFAULT_EXPORT_NAME = 'AI Analytics Result';

export function isResultLoaded(result) {
  return Boolean(result?.data && result?.columns && (result.data.length > 0 || result.columns.length > 0));
}

export function deriveMessageDisplayData(message, loadedData) {
  const hasInlineData = isResultLoaded(message);
  const hasLoadedData = isResultLoaded(loadedData);
  const source = hasInlineData ? message : hasLoadedData ? loadedData : null;

  return {
    hasInlineData,
    hasLoadedData,
    showData: Boolean(source),
    columns: source ? source.columns : [],
    rows: source ? source.data : [],
    executionTimeMs: source ? source.executionTimeMs ?? null : null,
    executedAt: source ? source.executedAt ?? null : null,
    truncated: Boolean(source?.truncated)
  };
}

export function exportBaseName(question, threadTitle) {
  return [question, threadTitle].map(value => (value || '').trim()).find(Boolean) || DEFAULT_EXPORT_NAME;
}

export function chartTypePrompt(type) {
  return `Render this as a ${type} chart.`;
}

export const REFINE_MODES = {
  QUERY: 'query',
  CHART: 'chart'
};
